export interface AuditSelectOption<T = string> {
  value: T;
  label: string;
}

// Values reproduced from the workbook's Sheet2 lookup tab and its Form Control ranges.
export const COUNTRY_OPTIONS = [
  "Angola",
  "Argentina",
  "Australia",
  "Brazil",
  "Canada",
  "Colombia",
  "Indonesia",
  "Kasaghtan",
  "Nigeria",
  "Papua Newguinea",
  "Thailand",
  "United Kingdome",
  "United States",
  "Venezuela",
];

export const SERVICE_COMPANY_OPTIONS = [
  "Halliburton",
  "Schlumberger",
  "BJ Services",
  "Other",
];

export const LAB_PERSONNEL_COUNT_OPTIONS = Array.from({ length: 15 }, (_, index) => index + 1);
export const TOTAL_WORKING_HOURS_OPTIONS = [10, 12, 14, 16, 18, 20, 24];

export const WORKING_HOURS_FROM_OPTIONS: AuditSelectOption[] = [
  { value: "N/A", label: "N/A" },
  { value: "5:00 AM", label: "5:00 AM" },
  { value: "6:00 AM", label: "6:00 AM" },
  { value: "7:00 AM", label: "7:00 AM" },
  { value: "8:00 AM", label: "8:00 AM" },
  { value: "9:00 AM", label: "9:00 AM" },
];

export const WORKING_HOURS_TO_OPTIONS: AuditSelectOption[] = [
  { value: "N/A", label: "N/A" },
  { value: "5:00 PM", label: "5:00 PM" },
  { value: "6:00 PM", label: "6:00 PM" },
  { value: "7:00 PM", label: "7:00 PM" },
  { value: "8:00 PM", label: "8:00 PM" },
  { value: "9:00 PM", label: "9:00 PM" },
  { value: "10:00 PM", label: "10:00 PM" },
  { value: "11:00 PM", label: "11:00 PM" },
  { value: "12:00 AM", label: "12:00 AM" },
];

// These Sheet2 lists are not connected to Form Controls in this workbook revision.
// They are exposed as suggestions while retaining free-text entry for legacy values.
export const AUDITOR_OPTIONS = [
  "Craig Gardner",
  "Brian Koons",
  "Deryck Williams",
  "Bob Carpenter",
  "Deryck Williams &",
  "Deryck Williams & Brian Koons",
  "Verland Granberry & Reinaldo Bruzual",
  "Craig Gardner & Reinaldo Bruzual",
  "Craig Gardner & Verland Granberry",
  "Craig Gardner & Deryck William",
  "Deryck William and Bob Carpenter",
  "Bob Carpenter & Deryck Willams",
  "Bob Carpenter & Verland Granberry",
  "Bob Carpenter & Reinaldo Bruzual",
  "Craig Gardner & Bob Carpenter",
  "Other",
];

export const LOCATION_OPTIONS = [
  "Alice",
  "Beigin",
  "Bogota",
  "Cabinda",
  "Dallas",
  "Denver",
  "Duncan",
  "El Reno",
  "Elk City",
  "Farmington",
  "Grand Junction",
  "Houston",
  "Kilgore",
  "Lafayette",
  "Lagos",
  "Laredo",
  "London",
  "Longview",
  "Maracaibo",
  "New Orleans",
  "Newquen",
  "Perlf",
  "Port Harcourt",
  "Rio de Janeiro",
  "Rock Springs",
  "San Antonio",
  "Scrabble",
  "Vernal",
];
